import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { NavController } from '@ionic/angular';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProfileStateDispatcher } from 'src/app/core/state/profile/profile.dispatcher';
import { ItemTypes } from 'src/app/core/firebase/club.service';
import { TimebankBundle } from './shop-home.page';
import { NavigationExtras } from '@angular/router';
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoAlertSettings } from 'src/app/sopo-popup/interfaces/alert';

@Injectable({
    providedIn: 'root',
})
export class ShopHomeService {
    cmsUrl = '';
    bearerToken = '';

    constructor(
        public http: HttpClient, 
        private profileService: ProfileStateDispatcher,
        private navCtrl: NavController,
        private sopoPopupService: SopoPopupService,
        ) {
            this.cmsUrl = environment.cmsUrl;
            this.bearerToken = environment.bearerToken;
    }

    getData(itemType: keyof ItemTypes) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .get<any>(this.cmsUrl + itemType, httpOptions)
            .pipe(filter((data) => data != null || data !== undefined));
    }

    getEmotesData() {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .get<any>(this.cmsUrl + 'emojis', httpOptions)
            .pipe(filter((data) => data != null || data !== undefined));
    }

    // getGoldData(): Observable<GoldBundle[]> {
    //     const httpOptions = {
    //         headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    //     }; 
    //     return this.http.get<any>(this.cmsUrl + 'golds', httpOptions).pipe(filter((data) => data != null || data !== undefined), map(data => data.bundles));
    // }

    verifyPromo(param: any) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: this.bearerToken }),
        };

        return this.http.post<any>(this.cmsUrl + 'appuser/avatars/discountcode', param, httpOptions);
    }

    purchaseItem(param: any, type: string) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: this.bearerToken }),
        };

        return this.http.post<any>(this.cmsUrl + `appuser/${type}/buy`, param, httpOptions); // avatars | felts | backgrounds | cards
    }

    async getUnlockedItems<T>(itemType: keyof ItemTypes): Promise<T[]> {
        const userId = await this.profileService.getMyID();
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: this.bearerToken }),
        };
        const result = await firstValueFrom(this.http.get<any>(this.cmsUrl + `appuser/${itemType}?user_id=${userId}`, httpOptions));
        return result[itemType];
    }

    getTimebankData(): Observable<TimebankBundle[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        const timebankObs: Observable<TimebankBundle[]> = this.http
            .get<any>(this.cmsUrl + 'timebanks', httpOptions)
            .pipe(filter((data) => data != null || data !== undefined),
            map(data => data.bundles));
        
            return timebankObs;
    }

    async showDialogAlert(header: string, subHeader?: string, message?: string) {
        this.sopoPopupService.clearViewContainer('app');
        const sopoAlertSettings: SopoAlertSettings = {
            header,
            subHeader,
            message: JSON.stringify(message).toString().replace(/"/g, ''),
            dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
        };
        this.sopoPopupService.showAlert('app', sopoAlertSettings);
    }

    navigateToSelectedTab() {
        this.navCtrl.navigateRoot('shop-home');
    }
}
